<template>
  <div style="padding:0 16px;">
    <slot></slot>
    <el-card class="box-card">
      <div class="steps">
        <div class="first">
          <div
            v-if="selectStep==='1'"
            :class="selectStep==='1'?'icon':''"
          >1</div>
          <i
            v-if="selectStep==='2'||selectStep==='3'"
            class="el-icon-circle-check"
          ></i>
          <div :class="selectStep==='1'?'titles':'titleGray'">核实订单信息</div>
        </div>
        <div class="line"> </div>
        <div class="first">
          <div
            v-if="selectStep==='2'"
            :class="selectStep==='2'?'icon':'iconGray'"
          >2</div>
          <i
            v-if="selectStep==='3'"
            class="el-icon-circle-check"
          ></i>
          <div :class="selectStep==='2'?'titles':'titleGray'">支付订单</div>
        </div>
        <div class="line"> </div>
        <div class="first">
          <div :class="selectStep==='3'?'icon':'iconGray'">3</div>
          <div :class="selectStep==='3'?'titles':'titleGray'">完成交易</div>
        </div>
      </div>
      <div v-if="selectStep==='1'">
        <div class="table">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :default-sort="{prop: 'date', order: 'descending'}"
          >
            <el-table-column
              prop="service_name"
              label="服务名称"
            >
            </el-table-column>
            <el-table-column
              prop="login_time"
              label="订购时长"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="生效时间"
            >
            </el-table-column>
            <el-table-column
              prop="money"
              label="价格（元）"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="input">
          <div class="inputContent">
            <div style=" width: 300px; display: flex;">
              <!-- <el-input placeholder="请输入兑换码"></el-input>
              <el-button>兑换</el-button> -->
            </div>
            <div>
              应付金额：￥<span style=" font-size: 24px;font-weight: bold;">{{tableData[0].money}}</span>
            </div>
          </div>
        </div>
        <div class="footer">
          <div>
            <el-button
              type="primary"
              @click="handlPayment()"
            >立即支付</el-button>
            <p>点击立即支付代表您已阅读并同意<span @click="jumpDing">《微客云集服务功能订购协议》</span></p>
          </div>
        </div>
      </div>
      <div v-if="selectStep==='2'">
        <div class="order">
          <p> 订单号：{{tableData[0].order_id}}</p>
          <p>请在24小时以内完成付款，过期将自动取消订单</p>
        </div>
        <div style=" margin: 0 160px;">
          <div class="zhifubao">
            <img
              src="@/assets/imgs/icon_alipay.png"
              alt=""
              srcset=""
            > 支付宝
            <i class="el-icon-success"></i>
          </div>
        </div>

        <div class="footer">
          <div>
            <el-button
              type="primary"
              @click="handlSusses()"
            >立即支付</el-button>

          </div>
        </div>
      </div>
      <div v-if="selectStep==='3'">
        <div class="third">
          <div
            class="success"
            v-if="result==='success'"
          >
            <i class="el-icon-success"></i>
            <div class="paySuccess">支付成功</div>
            <div class="tips">您已成功购买cms专业版，稍后立即生效</div>
            <div class="btns">
              <el-button @click="jumpHome">返回列表</el-button>
              <el-button
                @click="jumpRecharge"
                type="primary"
              >再次购买</el-button>
            </div>
            <div class="details">
              <div>
                <p>订单号：{{tableData[0].order_id}} </p>
                <p>订购产品：{{tableData[0].service_name}}</p>
                <p>订购时长：{{tableData[0].login_time}}</p>
                <p>付款金额：{{tableData[0].money}}</p>
              </div>
            </div>
          </div>
          <div
            class="success"
            v-if="result==='fail'"
          >
            <i class="el-icon-warning"></i>
            <div class="paySuccess">支付失败</div>
            <div class="tips">查询到您还未支付，如果您已经支付请稍等片刻在进行操作，系统将尽快为您处理。</div>
            <div class="btns">
              <el-button @click="jumpHome">返回列表</el-button>
              <el-button
                type="primary"
                @click="selectStep='2'"
              >再次支付</el-button>
            </div>

          </div>
        </div>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <div
        slot="title"
        style="padding:15px 0 0 0;font-size:20px;"
      >
        <i
          class="el-icon-warning"
          style="color:#E6A23C;"
        ></i> <span>请确认您是否支付完成?</span>
      </div>
      <span style="padding-left:30px ;">
        确认支付后请点击支付完成。
      </span>
      <div style="
    display: flex;
    align-items: center;
    justify-content: flex-end;margin-top:20px ;">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="getpay()"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'OpenPayment',
  props: {
    payorder: Array,

  },
  data () {
    return {
      dialogVisible: false,
      selectStep: '1',
      result: '',
      tableData: [],
      page: 'recharge'

    };
  },

  mounted () {
    this.getList()
  },

  methods: {
    getList () {

      this.tableData.push(this.payorder)
      console.log(this.tableData, "this.payorder 2222");
    },
    tableHeaderColor ({ rowIndex, }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    },
    handlPayment () {
      this.selectStep = '2'
    },
    getpay () {
      this.dialogVisible = false
      this.selectStep = '3'
      apis.index.orderDetail({
        id: parseInt(this.tableData[0].id)
      }).then(res => {
        console.log(res, "code");
        this.result = 'success'
      }).catch(err => {
        this.result = 'fail'
        console.log(err)
      })
    },
    handlSusses () {
      this.dialogVisible = true
      window.open('https://router.wikeyun.cn/open/balance/pay?order_id=' + this.tableData[0].id)
    },
    jumpDing () {
      window.open('https://www.wikeyun.cn/agreement/detail.html?id=344')
    },
    jumpRecharge () {
      this.page = "recharge"
      this.$emit("watch", this.page);
    },
    jumpHome () {
      this.page = "recharge"
      this.$emit("watch", this.page);
      this.tableData = []
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  margin-top: 0 !important;
  top: 50%;
  transform: translateY(-50%);
}

::v-deep .el-dialog__header {
  padding: 15px 20px;
  background: #fff !important;
}
::v-deep .el-dialog__body {
  padding: 20px 20px;
  background: #fff !important;
}

.box-card {
  width: 100%;
  height: 800px;
  padding: 50px 116px;

  .steps {
    display: flex;
    justify-content: center;
    align-items: center;
    .first {
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-circle-check {
        font-size: 32px;
        color: #0b4ffc;
        margin-right: 10px;
      }
      .icon {
        width: 32px;
        height: 32px;
        background: #0b4ffc;
        border-radius: 50%;
        text-align: center;
        line-height: 32px;
        color: #fff;
        margin-right: 10px;
      }
      .iconGray {
        width: 32px;
        height: 32px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 50%;
        text-align: center;
        line-height: 32px;
        color: rgba(0, 0, 0, 0.25);
        margin-right: 10px;
      }
      .titles {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }
      .titleGray {
        font-weight: bold;
        font-family: PingFangSC-Medium, PingFang SC;
        color: rgba(0, 0, 0, 0.25);
      }
    }

    .line {
      width: 192px;
      height: 1px;
      background: #e9e9e9;
      margin: 0 20px;
    }
  }
  .table {
    padding: 0 116px;
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .input {
    padding: 0 116px;
    margin-top: 50px;
    .inputContent {
      width: 100%;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
    }
  }
  .footer {
    margin-top: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .el-button {
      width: 160px;
      margin-bottom: 24px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      span {
        cursor: pointer;
        color: #0b4ffc;
      }
    }
  }
  .third {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    .success {
      text-align: center;
      i {
        font-size: 70px;
        color: #52c41a;
      }
      .el-icon-warning {
        color: #ff4d4f;
      }
      .paySuccess {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }
      .tips {
        margin: 8px 0 24px 0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
      .btns {
        margin-bottom: 40px;
      }
      .details {
        width: 557px;
        height: 198px;
        background: rgba(245, 245, 245, 0.5);
        border-radius: 2px;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .failTips {
        width: 557px;
        height: 148px;
        background: rgba(245, 245, 245, 0.5);
        border-radius: 2px;
        .failTipsContent {
          padding: 24px 40px;
          .tipsTitle {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
          }
          p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            text-align: left;
            margin-bottom: 10px;
            i {
              margin-right: 5px;
              font-size: 14px;
              color: #ff4d4f;
            }

            a {
              margin-left: 20px;
              color: #0b4ffc;
              .el-icon-arrow-right {
                color: #0b4ffc;
              }
            }
          }
        }
      }
    }
  }
  .order {
    margin: 0 160px;
    text-align: center;
    margin-top: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e9e9e9;
    p {
      text-align: left;
      margin-bottom: 10px;
    }
  }
  .zhifubao {
    position: relative;
    margin-top: 30px;
    width: 128px;
    height: 48px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    text-align: center;
    line-height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #0b4ffc;
    img {
      width: 25px;
      height: 24px;
    }
    .el-icon-success {
      position: absolute;
      font-size: 16px;
      top: 5px;
      right: 10px;
      color: #0b4ffc;
      cursor: pointer;
    }
  }
}
</style>